import { StreamingCameraType, IpSpeakerType } from "lib/types";
import { ReactNode, createContext, useState } from "react";
import { SiteInfo } from "lib/types";

type MapContextType = {
  sites: SiteInfo[];
  setSites: (newState: SiteInfo[]) => void;
  currentSiteId: number;
  setCurrentSiteId: (newState: number) => void;
  currentCameras: any[];
  setCurrentCameras: (newState: any[]) => void;
};

const initialValue = {
  sites: [],
  setSites: () => {},
  currentSiteId: 0,
  setCurrentSiteId: () => {},
  currentCameras: [],
  setCurrentCameras: () => {},
};

export const MapContext = createContext<MapContextType>(initialValue);

export default function MapProvider({ children }: { children?: ReactNode }) {
  const [sites, setSites] = useState(initialValue.sites);
  const [currentSiteId, setCurrentSiteId] = useState(
    initialValue.currentSiteId,
  );
  const [currentCameras, setCurrentCameras] = useState(
    initialValue.currentCameras,
  );
  return (
    <MapContext.Provider
      value={{
        sites,
        setSites,
        currentSiteId,
        setCurrentSiteId,
        currentCameras,
        setCurrentCameras,
      }}
    >
      {children}
    </MapContext.Provider>
  );
}
